
const themeContext = require.context('./', false, /\.scss$/);

const themeLoaders = themeContext.keys().reduce((acc, filePath) => {
  const name = filePath.replace('./', '').replace(/\.scss$/, '');
  const normalized = name.toLowerCase().replace(/[^a-z0-9]/g, '');
  acc[normalized] = () => themeContext(filePath);
  return acc;
}, {});

// Use 'light' theme as the fallback
const fallbackLoader = themeLoaders.light || (() => {});

/**
 * Known theme identifiers that can be referenced by env vars or runtime switches.
 */
export const AVAILABLE_THEMES = Object.keys(themeLoaders);

/**
 * Injects the CSS overrides for the requested theme.
 * Falls back to the light theme when the requested one is unavailable.
 *
 * @param {string} themeName - Name provided via env (`VUE_APP_THEME`) or runtime toggle.
 */
export function loadTheme(themeName = 'light') {
  const normalized = (themeName || 'light').toLowerCase().replace(/[^a-z0-9]/g, '');
  const loader = themeLoaders[normalized] || fallbackLoader;

  try {
    loader();
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`Theme "${themeName}" failed to load. Using light theme instead.`, error);
    }
    if (loader !== fallbackLoader) {
      fallbackLoader();
    }
  }
}
